var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMymenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756382630130,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 22821,
    width: 18,
    height: 18,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.191078 561.312102l98.624205 0 0-98.624205L68.191078 462.687898 68.191078 561.312102zM68.191078 758.560512l98.624205 0 0-98.624205L68.191078 659.936307 68.191078 758.560512zM68.191078 364.063693l98.624205 0 0-98.624205L68.191078 265.439488 68.191078 364.063693zM265.439488 561.312102l690.369434 0 0-98.624205L265.439488 462.687898 265.439488 561.312102zM265.439488 758.560512l690.369434 0 0-98.624205L265.439488 659.936307 265.439488 758.560512zM265.439488 265.439488l0 98.624205 690.369434 0 0-98.624205L265.439488 265.439488z",
    "p-id": 22822,
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMymenu);
export default __webpack_public_path__ + "static/media/mymenu.27582fe5.svg";
export { ForwardRef as ReactComponent };